import { openBlock as e, createElementBlock as t, createElementVNode as a } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, o = /* @__PURE__ */ a("path", { d: "M12.69 4.5a1.013 1.013 0 0 0-.667-.255 1 1 0 0 0-.363.071.936.936 0 0 0-.304.196L6.3 8.69a.835.835 0 0 0-.275.614c0 .23.099.45.275.614a.986.986 0 0 0 .667.254.99.99 0 0 0 .667-.254l4.388-3.577 4.336 3.577a.987.987 0 0 0 .667.254c.25 0 .49-.092.666-.254a.87.87 0 0 0 .209-.284.81.81 0 0 0 0-.672.87.87 0 0 0-.209-.283l-5.003-4.18Zm-1.38 15.232a.993.993 0 0 0 1.03.185.937.937 0 0 0 .304-.196l5.054-4.179a.835.835 0 0 0 .276-.614c0-.23-.099-.45-.276-.613a.986.986 0 0 0-.666-.254c-.25 0-.49.091-.667.254l-4.388 3.576-4.336-3.576a.986.986 0 0 0-.667-.254c-.25 0-.49.091-.666.254a.869.869 0 0 0-.21.283.81.81 0 0 0 0 .672.87.87 0 0 0 .21.284l5.003 4.178Z" }, null, -1), l = [
  o
];
function n(r, s) {
  return e(), t("svg", c, [...l]);
}
const _ = { render: n };
export {
  _ as default,
  n as render
};
